import { render, staticRenderFns } from "./partner.vue?vue&type=template&id=0d623dc0&"
import script from "./partner.vue?vue&type=script&lang=ts&"
export * from "./partner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports